import * as React from "react";
import {Grid} from "tabler-react";
import SiteWrapper from "../../SiteWrapper.react";
import Catalogo from "../../components/Catalogo";
import {PlataformasForm}  from "../../Catalogos";

import Crud_Catalogos from "../../herramientas/Crud_Catalogos";
var currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
function getfuntion (metodo = "get", obj = [], id = "", catalogo = "", stateVar = "", hiddenModl = "") {
  Crud_Catalogos(catalogo, "perfiles", metodo, id, obj, "", stateVar, hiddenModl, []).then((returnVal) => {
    switch (metodo) {
      case "get":
      if (stateVar === "funcionalidades") {
        for( let item of returnVal){
          if(item.nombre == "Plataformas"){ return true; }
        }
        window.history.back();
        window.location.href = "403";
      }  break;
      default:
        break;
    }
  }).catch(err => { console.log("Error desconocido ...."+ err); })
}
function PlataformasPage() {
  getfuntion("get", "", "", "funcionalidades/Administracion/"+currentUser[0].perfil.id, "funcionalidades");
  return (
    <SiteWrapper>
        <Grid.Col sm={12} lg={12}>
         <Catalogo Ctlogo="plataformas" tamanio="100%" FCtlogo= { PlataformasForm }
                   catalogos= {{ 0:"otd",
                                 1:"plataformasTipos",
                                 2:"usuarios",
                                 3:"navieras",
                                 4:"operacionesTipo",
                                 5:"operacionesEstatus",
                                 6:"rutasEstatus",
                                 7:"movimientosTipo",
                                8:"funcionalidades",
                                9:"acumuladores",
                                10:"unidadesMarcas",
                                11:"unidadTipo",
                                12:"unidadEstatusOperacion",
                                13:"unidadTipoColocacion",
                                14:"gpsHardware",
                                15:"etaConfiguracion",
                                16:"etiquetas",
                                17:"alertasTipos",
                                18:"alertasCategorias",
                                19:"privilegios",
                                20:"incidencias",
                                21:"plataformas"
                               } } />
        </Grid.Col>
    </SiteWrapper>
  );
}
export default PlataformasPage;
